/* globals lp, jui, Class, eventTracker */
var rxUi = window.rxUi;

module.exports = Class.create(
  lp.editor.BuilderModal,
  lp.ModuleComponent,
  {
    type:'lp-code',

    initialize: function($super){
      this.controls = {};
      var self = this;

      $super({
        title: 'Embed Custom HTML Code',
        actions: [{
          id: 'done',
          class: 'save-code-button action',
          label: 'Save Code',
          action: this.embedIfValid.bind(this)
        },
        {
          id: 'cancel',
          class: 'push-left',
          label: 'Discard',
          action: function() {
            self._uiBinding.onNext({
              type: 'cancel'
            });
          }
        }],
        attributes: {
          className: 'modal-panel code-html-panel'
        },
        layoutRules: {
          method: lp.editor.BuilderModal.fitToViewport,
          options: {
            padding: 12,
            size:{width:1000, height:600}
          }
        },
        closeX: true
      });
    },

    installUI: function( $super ) {
      $super();

      this._uiBinding = new rxUi.Binding('CodeEditor')
        .subscribeDomainEvents(this.domainEvents, this);

      this.warn = this.actionBar.insert( new Element('div', {className:'warn'}).update('You must enter valid code'));
      this.controls.codeEditor = this.contentPanel.insert( new jui.CodeEditor( {
        label: "Enter HTML code that you would like to embed below:",
        toggleCheckboxYPosition: '5px'
      } ) );

      this.warn.hide();
    },

    requestFocus: function(){
      window.editor.keyController.requestFocus(this);
    },

    onkeydown: function() {},

    onkeyup: function(){},

    blur: function(){},

    embedIfValid: function() {
      this.controls.codeEditor.isValidContentHTML(this, this.embed);
    },

    embed: function(force) {
      if (Boolean(force)) {
        this._uiBinding.onNext({
          type   : 'save',
          html   : this.controls.codeEditor.getValue(),
          valid  : this.controls.codeEditor.isValid(),
          errors : this.controls.codeEditor.getErrors()
        });

        if (typeof eventTracker !== 'undefined') {
          eventTracker.track("Add a Custom HTML Object", "Editor");
        }
      }
    },

    open: function($super, elm, options) {
      $super();

      if (options && options.callback) {
        this.options.callback = options.callback;
      }

      var content = '';
      var isValid = true;
      if (elm !== null) {
        var model = elm.model;
        content = model.get('content.html');
        isValid = model.exists('content.valid') ? model.get('content.valid') : true;
      }

      this.controls.codeEditor.setValue(content);
      this.controls.codeEditor.focus();
      this.controls.codeEditor.setIsValid(isValid);
      this.controls.codeEditor.showHTMLWarningIfInvalid(this, this.embedIfValid, isValid);
      this.requestFocus();
    },

    close: function($super) {
      delete this.options.callback;
      $super();
    },

    domainEvents: {
      cancel: function() {
        this.hideWarningDialog();
        this.close();
      },

      save: function(ev) {
        this.hideWarningDialog();
        if (this.options.callback) {
          this.options.callback({
            html   : ev.html,
            valid  : ev.valid,
            errors : ev.errors
          });
        }
        this.close();
      }
    }

  }
);



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-code/code_element_builder.js
// module id = 1482
// module chunks = 0